<template>
	<article :class="{ disabled: disabled }" class="pf-range-slider">
		<div class="pf-range-slider__label" v-html="label"></div>
		<div class="pf-range-slider__wrap">
			<fieldgroup>
				<label for="minValue">от</label>
				<input
					type="tel"
					:name="fieldNames[0]"
					id="minValue"
					v-model="minValueField"
					@keydown.enter.stop="fieldHandler"
					@change="fieldHandler"
				/>
			</fieldgroup>
			<fieldgroup>
				<label for="maxValue">до</label>
				<input
					type="tel"
					:name="fieldNames[1]"
					id="maxValue"
					v-model="maxValueField"
					@keydown.enter.stop="fieldHandler"
					@change="fieldHandler"
				/>
			</fieldgroup>
		</div>
		<vue-slider
			v-model="value"
			:enable-cross="false"
			:min="min"
			:max="max"
			:tooltip="'none'"
			@dragging="sliderHandler"
			@click="updateSliderValues(value)"
			@drag-end="$emit('rangeSliderUpdate', fieldNames, value)"
		/>
	</article>
</template>

<script>
import VueSlider from 'vue-slider-component'

export default {
	name: 'RangeSlider',
	props: {
		sliderData: {
			type: Object,
			default: () => {},
		},
		label: {
			type: String,
			default: '',
		},
		fieldNames: {
			type: Array,
			default: [],
		},
		onloadValue: {
			type: Array,
			default: [],
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		VueSlider,
	},
	data: function () {
		return {
			value: [this.sliderData.min, this.sliderData.max],
			min: this.sliderData.min,
			max: this.sliderData.max,
			maxValueField: this.formatNumbers(this.sliderData.max),
			minValueField: this.formatNumbers(this.sliderData.min),
		}
	},
	methods: {
		sliderHandler(val) {
			this.maxValueField = this.formatNumbers(val[1])
			this.minValueField = this.formatNumbers(val[0])
		},

		fieldHandler() {
			this.value = [
				Number(this.minValueField.replace(/\s/g, '')),
				Number(this.maxValueField.replace(/\s/g, '')),
			]
			this.maxValueField = this.formatNumbers(this.value[1])
			this.minValueField = this.formatNumbers(this.value[0])

			this.$emit('rangeSliderUpdate', this.fieldNames, this.value)
		},

		updateSliderValues(val) {
			this.maxValueField = this.formatNumbers(val[1])
			this.minValueField = this.formatNumbers(val[0])
			this.$emit('rangeSliderUpdate', this.fieldNames, this.value)
		},

		formatNumbers(number) {
			return new Intl.NumberFormat('ru-RU').format(number)
		},
	},
	watch: {
		disabled(newVal) {
			this.value = [this.sliderData.min, this.sliderData.max]
			this.maxValueField = this.formatNumbers(this.sliderData.max)
			this.minValueField = this.formatNumbers(this.sliderData.min)
			this.$emit('rangeSliderUpdate', this.fieldNames, this.value)
		},
	},
	created() {
		if (this.onloadValue[0]) {
			this.minValueField = this.formatNumbers(this.onloadValue[0])
			this.value[0] = this.onloadValue[0]
		}

		if (this.onloadValue[1]) {
			this.maxValueField = this.formatNumbers(this.onloadValue[1])
			this.value[1] = this.onloadValue[1]
		}
	},
}
</script>
